import React from "react";
import { utils } from "~/utils";
import "./history.scss";

export default ({ history }) => {
    return (
        <div className="card history">
            <div className="card-header">CPO History</div>
            <div className="card-body">
                <table className="history-table">
                    <tbody>
                        <tr>
                            <td>{history.is_history_log ? 'Last updated' : 'Date created' }</td>
                            <td>{utils.renderDate(history.creation_date)}</td>
                        </tr>
                        <tr>
                            <td>Date Requested</td>
                            <td>{utils.renderDate(history.date)}</td>
                        </tr>
                        <tr>
                            <td>Date Approved</td>
                            <td>{utils.renderDate(history.creation_date)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
